import React, { FC, lazy, LazyExoticComponent, Suspense } from 'react'
import { getProductName } from '@dg-util'
import { QuoteV2Type } from '../../../types/ApiV2'
import { IconType } from '../../../types/interface/icon.interface'

interface CardVehicleProps {
  offer: Partial<QuoteV2Type>
}

// Cached per product name so the lazy component identity is stable across
// re-renders. Calling `lazy()` fresh on every render (as this used to) makes
// React treat each render's result as a brand-new component type, unmounting
// and re-suspending this subtree on every keystroke/checkbox click on the
// Verify step instead of once on mount.
const productContentCache: Partial<Record<string, LazyExoticComponent<FC<CardVehicleProps>>>> = {}

const getProductContent = (product: string): LazyExoticComponent<FC<CardVehicleProps>> => {
  if (!productContentCache[product]) {
    productContentCache[product] = lazy(() => import(`./VerifyCardContent.${product}.tsx`))
  }
  return productContentCache[product] as LazyExoticComponent<FC<CardVehicleProps>>
}

const VerifyCardContent: FC<CardVehicleProps> = ({ offer }) => {
  const VerifyCardProductContent = getProductContent(getProductName())

  return (
    <Suspense fallback={IconType.LOADING}>
      <VerifyCardProductContent offer={offer} />
    </Suspense>
  )
}

export default VerifyCardContent
